import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '@ukam/core/tokens/api-base-url.token';

@Injectable({
  providedIn: 'root',
})
export class FilterSupportApiService {
  private readonly apiBaseUrl = inject(API_BASE_URL);

  private readonly http = inject(HttpClient);
  private readonly url = `${this.apiBaseUrl}/filter-supports`;

  public getSupport(): Observable<any> {
    return this.http.get<any>(`${this.url}`);
  }



}
